module.exports = __webpack_public_path__ + "img/icon_csv.fb07a116.png";